import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from "dompurify";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import CommonStructured from "../../components/common-components/CommonStructured";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import { fetchCentralisedPlanCategoriesData } from "../../redux/plans-reducers/plansSlice";
import PlanCategoriesLists from "../../components/centralised-plan-system/plan-categories/PlanCategoriesLists";
import PlanCategoryForm from "../../components/centralised-plan-system/plan-categories/PlanCategoryForm";

const PlansCategories = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { centralisedPlanCategoriesLoading } = useSelector(
    (state) => state.plans
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getPlansCategoriesData = (filters) => {
    dispatch(
      fetchCentralisedPlanCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getPlansCategoriesData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Gym Categories Management">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div className="createNewCTOModalContainer mod-width-50p">
            {modValues.modName !== "add" && modValues.modName !== "edit" && (
              <ModalHeadAndClose
                title={
                  modValues.modName === "description"
                    ? modValues.rowData?.name || " "
                    : modValues.modName?.replace(/_/g, " ")
                }
                onClose={onCloseModal}
              />
            )}

            {modValues.modName === "description" ? (
              <>
                {/* <div className="discussionModalMessage mt30">
                  <p
                    className="message"
                    dangerouslySetInnerHTML={{
                      __html:
                        modValues.rowData?.description ||
                        "No Content Available",
                    }}
                  ></p>
                </div> */}
                <div className="discussionModalMessage mt30">
                  <p
                    className="message"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        modValues.rowData?.description || "No Content Available"
                      ),
                    }}
                  ></p>
                </div>

                {/* <div className="discussionModalMessage mt30">
                  <p className="message">
                    {modValues.rowData?.description || "No Content Available"}
                  </p>
                </div> */}
              </>
            ) : modValues.modName === "add" || modValues.modName === "edit" ? (
              <PlanCategoryForm
                isEdit={modValues.modName === "edit"}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={() => getPlansCategoriesData(filters)}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Gym Categories"}
              isReload={() => getPlansCategoriesData(filters)}
              createBtnTxt={"+ Add New Category"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="plans-categories"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={centralisedPlanCategoriesLoading}
              searchPlaceHolder="Search by category name..."
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <PlanCategoriesLists
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getPlansCategoriesData(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default PlansCategories;
